// 3rd Party
import moment from 'moment';
import 'jquery-validation/dist/jquery.validate';
import 'jquery-validation/dist/additional-methods';
import {
    stateByZipCode
} from './api';

$.validator.addMethod('dateOfBirth', function (value, element) {
    var year = value.split('/');
    return (
        value.match(/^\d\d?\/\d\d?\/\d\d\d\d$/) &&
        moment(value, 'MM/DD/YYYY', true).isValid() &&
        parseInt(year[2]) <= 2002 &&
        parseInt(year[2]) >= 1910
    );
}, 'A valid date of birth is required.');

$.validator.addMethod('customEmail', function (value, element) {
    return this.optional(element) || /^[A-Za-z0-9]+([-._][A-Za-z0-9]+)*@([A-Za-z0-9]+(-[A-Za-z0-9]+)*\.)+[A-Za-z]{2,4}$/.test(value) && /^(?=.{1,64}@.{4,64}$)(?=.{6,100}$).*/.test(value);
}, 'Please enter a valid email address.');

$.validator.addMethod('squareFootage', function (value, element) {
    return this.optional(element) || value > -1 && value <= 25000;
}, 'A valid square footage is required to continue.');

$.validator.addMethod('yearBuilt', function (value, element) {
    return this.optional(element) || value <= (new Date()).getFullYear() + 1 && value >= 1800;
}, 'A valid year built is required to continue.');

$.validator.addMethod('noEmpty', function (value, element) {
    return value.replace(/\s/g, '').length;
}, 'A valid value is required.');

$.validator.addMethod('noEmptyOptional', function (value, element) {
    return this.optional(element) || value.replace(/\s/g, '').length;
}, 'A valid value is required.');

$.validator.addMethod('googleZipcode', function (value, element) {

    if (value.length < 5) {
        $('.wm-js-address-disclaimer').hide();
        $('.ah-js-address-disclaimer').hide();
        $('.wm-js-invalid-state-disclaimer').hide();
        $('button').prop('disabled', true);

        return false;
    }

    var state = stateByZipCode(value);

    if (state === 'none') {
        $('.wm-js-address-disclaimer').hide();
        $('.ah-js-address-disclaimer').hide();
        $('.wm-js-invalid-state-disclaimer').hide();
        $('button').prop('disabled', true);

        return false;
    }

    if (state === 'CA' ||
        state === 'TX' ||
        state === 'NV' ||
        state === 'NM' ||
        state === 'UT') {
        $('.wm-js-address-disclaimer').show();
        $('button').prop('disabled', true);

        return false;
    } else if (state === 'AZ') {
        $('.ah-js-address-disclaimer').show();
        $('button').prop('disabled', true);

        return false;
    } else if (state !== 'CO') {
        $('.wm-js-invalid-state-disclaimer').show();
        $('button').prop('disabled', true);

        return false;
    } else {
        $('.wm-js-address-disclaimer').hide();
        $('.ah-js-address-disclaimer').hide();
        $('.wm-js-invalid-state-disclaimer').hide();
        $('button').prop('disabled', false);

        return true;
    }

}, 'A valid value is required.');

export const showPopoverErrorsCallback = function (errorMap, errorList, placement) {
    $.each(this.successList, function (index, value) {
        $(value)
            .removeClass('is-invalid')
            .addClass('is-valid');
    });
    $.each(errorList, function (index, value) {
        $(value.element).addClass('is-invalid');
    });
};